import { useLayout } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { hocs as pageHocs } from 'modules/page';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useHideCompanyHeader } from 'shared/components';
import { getPath, Path } from 'urlBuilder';

import { PageContent } from '../components/PageContent/PageContent';
import PageSkeleton from '../components/PageContent/PageSkeleton';
import { MY_REQUESTS_LIST_PAGE_ID, PAGE_ID } from '../config';
import PageError from '../containers/PageError/PageError';
import { useLeavePage } from '../hooks/useLeavePage';
import useMyRequestsListPageData from '../hooks/useMyRequestsListPageData';

export const MyRequestsListPage: FC = () => {
    const activePageId = useSelector(selectors.navigation.getActivePageId);
    const innerActivePageId = useSelector(selectors.navigation.getInnerActivePageId);

    useLayout({ hasHeader: true, hasDrawer: true });
    useHideCompanyHeader();
    useLeavePage();

    const { isInitialLoading, filter, isError } = useMyRequestsListPageData();

    const generateRequestUrl = useCallback(
        (requestId: string, companyId: string) => {
            return getPath(Path.requestMyListWithCompany, filter, companyId, { requestId });
        },
        [filter]
    );

    if (isError) {
        return <PageError />;
    }

    if (isInitialLoading || activePageId !== PAGE_ID || innerActivePageId !== MY_REQUESTS_LIST_PAGE_ID) {
        return <PageSkeleton />;
    }

    return <PageContent requestListPage='my' generateRequestUrl={generateRequestUrl} />;
};

export default pageHocs.withProtected({ Page: MyRequestsListPage });
